export const addressRegex = /^[a-zA-Z0-9\s'".,/@#&\-_:;()]*$/;
export const numericRegex = /\d/;
